import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

// Sources the organization is connected to or already has orders from.
// Fetched once: skipped while a request is in flight or the list is loaded.
export const getOrderSources = createAsyncThunk(
  "orderSources/getOrderSources",
  async (_, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(`${config.API_URL}/orders/sources/`);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data ?? { Error: error.message });
    }
  },
  {
    condition: (_, { getState }) => {
      const { loading, items } = getState()?.orderSources ?? {};
      return !loading && !items?.length;
    },
  }
);

// Every source the backend knows, the same for all organizations. Only for
// places where a source is chosen before it is used (Order Room modal).
export const getAllOrderSources = createAsyncThunk(
  "orderSources/getAllOrderSources",
  async (_, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(`${config.API_URL}/orders/sources/`, {
        params: { all: true },
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data ?? { Error: error.message });
    }
  },
  {
    condition: (_, { getState }) => {
      const { loading, items } = getState()?.orderSources?.all ?? {};
      return !loading && !items?.length;
    },
  }
);
